import classNames from 'classnames';
import PropTypes from 'prop-types';

import { generateQeId } from '@ctct/ui-react';

const propTypes = {
  className: PropTypes.string,
  /** Identifier used by QE */
  'data-qe-id': PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  classes: PropTypes.arrayOf(PropTypes.string),
  classBase: PropTypes.string,
};

const defaultProps = {
  className: '',
  classes: [],
  classBase: '',
  value: '',
};

const InfoRow = (props) => {
  const { 'data-qe-id': qeId, label, value, classBase, ...attributes } = props;

  return (
    <div {...attributes} className="order-summary-section-row">
      <span
        className={classNames(`order-summary-${classBase}-label`, 'order-summary-body-left')}
        data-qe-id={generateQeId(qeId, classBase)}
      >
        {label}
      </span>
      <span
        className={classNames(`order-summary-${classBase}-value`, 'order-summary-body-right')}
        data-qe-id={generateQeId(qeId, `${classBase}-value`)}
      >
        {value}
      </span>
    </div>
  );
};

InfoRow.propTypes = propTypes;
InfoRow.defaultProps = defaultProps;

export default InfoRow;
